import { login, logout, getInfo, apiPostLarksWitchConfig } from '@/api/user';
import {setImServiceStatus} from '@/api/im.js'
import { getToken, setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import { Encrypt } from '@/utils/crypto';
import SocketInstance from '@/im-server/socket-instance';
import Vue from 'vue';

const state = {
	token: getToken('access_token'),
	// s_token: getToken('s_access_token'),
	name: '',
	avatar: '',
	introduction: '',
	roles: [],
	agentId:'',//坐席id2018122000010366DWCS5NRE
	serviceStatus: JSON.parse(sessionStorage.getItem('service_status')) || {},//当前坐席状态
	brandId:'',//当前品牌id
	userInfo: {},
	lark_switch_url: '',
	needCreateSubBrand: false,
};

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token;
	},
	// SET_S_TOKEN: (state, token) => {
		// state.s_token = token;
	// },
	SET_INTRODUCTION: (state, introduction) => {
		state.introduction = introduction;
	},
	SET_NAME: (state, name) => {
		state.name = name;
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar;
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles;
	},
	SET_SERVICESTATUS: (state, status) => {
		state.serviceStatus = status;
	},
	SET_AGENT_ID: (state,agentId) => {
		state.agentId = agentId;
	},
	SET_USER_INFO: (state,userInfo) => {
		userInfo.headImg = userInfo.headImg ? userInfo.headImg : `${process.env.VUE_APP_BASE_CDN}/static/images/avat.png`;
		state.userInfo = userInfo;
	},
	SET_BRAND_ID: (state,brandId) => {
		state.brandId = brandId;
	},
	SET_LARK_SWITCH_URL: (state, lark_switch_url) => {
		state.lark_switch_url = lark_switch_url;
	},
	SET_NEED_CREATE_SUB_BRAND: (state, needCreateSubBrand) => {
		state.needCreateSubBrand = needCreateSubBrand;
	}
};

const actions = {
	// user login
	login({ commit, state, dispatch, rootState }, userInfo) {
		const { username, password, captcha, captchaid, qrcode } = userInfo;
		return new Promise((resolve, reject) => {
			// Encrypt(password)
			login({ username: username.trim(), password: Encrypt(password), captcha: captcha, captchaid: captchaid, qrcode: qrcode 
			}).then(response => {
				/* const { data } = response;
				commit('SET_TOKEN', data.access_token);
				// setToken(data.access_token)
				setToken("access_token", data.access_token);
				setToken("refresh_token", data.refresh_token);
				localStorage.setItem('access_token', data.access_token);
				localStorage.setItem('refresh_token', data.refresh_token);
				if(rootState.telService.StoreIsSignIn) {
					dispatch('telService/StoreSoftPhoneInit', null, { root: true });
				}
				// apiPostSToken().then(res => {
				// 	commit('SET_S_TOKEN', res.data);
				// 	setToken("s_access_token", res.data);
				// });
				} */
				/* apiPostSToken().then(res => {
					commit('SET_S_TOKEN', res.data);
					setToken("s_access_token", res.data);
				}); */
				resolve(response);
			}).catch(error => {
				reject(error);
			});
		});
	},
	setToken({ commit, state, dispatch, rootState }, tokenInfo) {
		commit('SET_TOKEN', tokenInfo.access_token);
		setToken("access_token", tokenInfo.access_token);
		setToken("refresh_token", tokenInfo.refresh_token);
		localStorage.setItem('access_token', tokenInfo.access_token);
		localStorage.setItem('refresh_token', tokenInfo.refresh_token);
		// apiPostSToken().then(res => {
		// 	commit('SET_S_TOKEN', res.data);
		// 	setToken("s_access_token", res.data);
		// });
		if(rootState.telService.StoreIsSignIn) {
			dispatch('telService/StoreSoftPhoneInit', null, { root: true });
		}
	},

  // get user info
	getInfo({ commit, state }) {
		return new Promise((resolve, reject) => {
			getInfo(state.token).then(response => {
				// const { data } = response
				localStorage.setItem('dashboard-ocs-user-info', JSON.stringify(response.data));
				localStorage.setItem('user_type', response.data.userType);
				let account = [];
				account.push(response.data.account);
				const data = {
					roles: account,
					introduction: 'I am a super administrator',
					avatar: response.data.headImg ? response.data.headImg : `${process.env.VUE_APP_BASE_CDN}/static/images/avat.png`,
					name: response.data.nickname,
					brandIdentify:response.data.brandIdentify
				};
				if (!data) {
					reject('验证失败，请重新登录');
				}
				const { roles, name, avatar, introduction,brandIdentify } = data;
				if (!roles || roles.length <= 0) {
					reject('getInfo: 角色必须是非空数组!');
				}
				commit('SET_ROLES', roles);
				commit('SET_NAME', name);
				commit('SET_AVATAR', avatar);
				commit('SET_AGENT_ID', response.data.userId);
				commit('SET_INTRODUCTION', introduction);
				commit('SET_BRAND_ID', brandIdentify);
				commit('SET_USER_INFO', response.data);
				localStorage.setItem('GlobalUserInfo', JSON.stringify(response.data));

				apiPostLarksWitchConfig({brandIdentify: brandIdentify}).then(res => {
					if(res?.data?.length > 0) {
						localStorage.setItem('dashboard-ocs-lark-url', res.data?.[0]?.larkSwtichURL);
						commit('SET_LARK_SWITCH_URL',res.data?.[0]?.larkSwtichURL);
					}
				});
				// apiPostLarksWitchConfig({brandIdentify: brandIdentify}).then(res => {
				// 	if(res.data.length > 0) {
				// 		response.data['larkSwitch'] = res.data?.[0]?.larkSwtichURL;
				// 	}
					commit('SET_ROLES', roles);
					commit('SET_NAME', name);
					commit('SET_AVATAR', avatar);
					commit('SET_AGENT_ID', response.data.userId);
					commit('SET_INTRODUCTION', introduction);
					commit('SET_BRAND_ID', brandIdentify);
					commit('SET_USER_INFO', response.data);
				// }).catch(error => {
				// 	removeToken()
				// 	router.push(`/login`);
				// });
				
				resolve(data);
			}).catch(error => {
				removeToken()
				// router.push('/login')
				router.push(`/login`);
				// reject(error);
			});
		})
	},

  // user logout
	logout({ commit, state, dispatch, rootState }) {
		return new Promise((resolve, reject) => {
			if(rootState.telService.StoreIsSignIn) {
				dispatch('telService/StoreSoftPhoneInit', null, { root: true });
			}
			SocketInstance.close();
			Vue.prototype.$iMLocalforage.clear();
			logout({
				brand: state?.userInfo?.brandIdentify,
				account: state?.userInfo?.account,
				agentCode: state?.userInfo?.agentCode
			}).then((res) => {
				commit('SET_TOKEN', '');
				// commit('SET_S_TOKEN', '');
				commit('SET_ROLES', []);
				commit('SET_USER_INFO', {});
				commit('SET_SERVICESTATUS',{})
				removeToken();
				resetRouter();
				localStorage.clear()
				dispatch('tagsView/delAllViews', null, { root: true });
				if(res.data && res.data.redirectUrl) {
					window.location.href = res.data.redirectUrl;
				} else {
					router.push(`/login`);
				}
				// router.push(`/login?redirect=${router?.currentRoute?.fullPath}`);
				resolve();
			}).catch(error => {
				reject(error);
			});
		});
	},

  // remove token
	resetToken({ commit }) {
		return new Promise(resolve => {
			commit('SET_TOKEN', '');
			// commit('SET_S_TOKEN', '');
			commit('SET_ROLES', []);
			localStorage.clear()
			removeToken();
			resolve();
		});
	},

//   // dynamically modify permissions
// 	async changeRoles({ commit, dispatch }, role) {
// 		const token = role + '-token';
// 		commit('SET_TOKEN', token);
// 		setToken(token);
// 		const { roles } = await dispatch('getInfo');
// 		resetRouter();
// 		// generate accessible routes map based on roles
// 		const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true });
// 		// dynamically add accessible routes
// 		router.addRoutes(accessRoutes);
// 		// reset visited views and cached views
// 		dispatch('tagsView/delAllViews', null, { root: true });
// 	},
	changeServiceStatus({commit}, status) {
		commit('SET_SERVICESTATUS', status);
		localStorage.setItem('service_status',JSON.stringify(status))
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};
